import React, { useEffect, useState } from "react";
import TablePosts from "./components/TablePosts";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd, MdCategory, MdFilterList } from "react-icons/md";

function Posts() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`/api_w/postcategories`, {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        setCategories(response.data.data);
      } catch (error) {
        toast.error("Error fetching kategori: " + (error.response?.data?.message || error.message));
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="mt-5 px-2">
      {/* Page Header */}
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Manajemen Postingan</h2>
          <p className="text-sm text-gray-500 mt-1">Kelola semua postingan dan berita</p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/admin/categories")}
            className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-5 py-3 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 transition-colors dark:bg-navy-700 dark:text-white dark:border-navy-600"
          >
            <MdCategory className="h-4 w-4" />
            Kategori
          </button>
          <button
            onClick={() => navigate("/admin/add-posts")}
            className="flex items-center gap-2 rounded-xl bg-brand-500 hover:bg-brand-600 px-5 py-3 text-sm font-bold text-white shadow-sm transition-colors"
            style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
          >
            <MdAdd className="h-5 w-5" />
            Tambah Postingan
          </button>
        </div>
      </div>

      {/* Filter Card */}
      <div className="mb-4 flex items-center gap-3 rounded-2xl bg-white p-4 shadow-sm dark:bg-navy-700">
        <MdFilterList className="h-5 w-5 text-gray-400 flex-shrink-0" />
        <span className="text-sm font-medium text-gray-600 dark:text-white whitespace-nowrap">Filter Kategori:</span>
        <select
          className="flex-1 max-w-xs rounded-xl border border-gray-200 bg-gray-50 px-3 py-3 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 dark:bg-navy-800 dark:border-navy-600 dark:text-white"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">Semua Kategori</option>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>{category.name}</option>
          ))}
        </select>
      </div>

      {/* Table Card */}
      <div className="rounded-2xl bg-white shadow-sm overflow-hidden dark:bg-navy-700">
        <TablePosts selectedCategory={selectedCategory} />
      </div>
    </div>
  );
}

export default Posts;
